<template>
  <div
    id="accountprofile"
    class="mobile-card-select d-sm-none profile-account fixed-mp-cls"
  >
    <div class="mobile-login" v-if="!web_user">
      <div class="login-card-mobile px-0">
        <div class="back-cart">
          <router-link :to="{ name: 'home' }" class="back-loyalty">
            <svg class="rightarrow" fill="none">
              <use xlink:href="#left-arrow" />
            </svg>
          </router-link>
        </div>
        <h4>
          {{ _T('Login To') + ' ' }}
          {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order') }}
        </h4>
        <div class="login-btns">
          <button class="btn btn-solid d-block" @click="$bvModal.show('login')">
            {{ _T('Login') }}
          </button>
          <h6 class="d-block mt-2">{{ _T(`Don't have an account`) }}?</h6>
          <button
            class="btn btn-outline d-block"
            @click="$bvModal.show('signup')"
          >
            {{ _T('Register') }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="web_user">
      <div class="select-card p-0 mb-0">
        <div class="my-account" v-if="!domainBasedBrand">
          <h4>{{ _T('My Account') }}</h4>
          <span class="badge"
            ><img src="/images/svg/currency/AED.svg" alt="" />

            {{ currency }} {{ Num.price(loyalty_balance) }}</span
          >
        </div>
        <div class="media-user media">
          <img :src="web_user.avatar" alt="" class="update_img_0" />
          <div class="media-body">
            <h5>{{ web_user.name }}</h5>
            <span>{{ web_user.email }}</span>
            <router-link :to="{ name: 'mobile_profile' }" class="profile-open">
              {{ _T('Edit') }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="select-card pb-0" v-if="isModuleEnable('Loyalty')">
        <div class="loyalty-point">
          <h6>{{ _T('my loyalty point') }}</h6>
          <div class="media">
            <img src="/images/checkout/cashback.png" alt="" />
            <div class="media-body">
              <h6>{{ _T('Loyalty Point') }}</h6>
              <h4 class="font-primary">
                {{ currency }} {{ Num.price(loyalty_balance) }}
              </h4>
            </div>
          </div>
          <!-- <ul>
            <li>
              <router-link
                :to="{ name: 'mobile-loyalty' }"
                class="loyalty-open"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M16 11H13V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13H16C16.2652 13 16.5196 12.8946 16.7071 12.7071C16.8946 12.5196 17 12.2652 17 12C17 11.7348 16.8946 11.4804 16.7071 11.2929C16.5196 11.1054 16.2652 11 16 11Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('Loyalty Point History') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'mobile_loyalty_usage' }"
                class="loyaltyuse"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M12 10C11.7348 10 11.4804 10.1054 11.2929 10.2929C11.1054 10.4804 11 10.7348 11 11V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('How to use loyalty points') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
          </ul> -->
        </div>
      </div>

      <div class="select-card pb-0">
        <div class="loyalty-point">
          <h6>{{ _T('My Address') }}</h6>
          <ul>
            <li>
              <router-link :to="{ name: 'profile.addresses' }">
                <svg
                  id="Capa_1"
                  enable-background="new 0 0 512 512"
                  height="512"
                  viewBox="0 0 512 512"
                  width="512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="XMLID_1213_">
                    <g id="XMLID_410_">
                      <path
                        id="XMLID_1206_"
                        d="m497.799 169.854-236-168c-3.472-2.472-8.127-2.472-11.599 0l-236 168c-3.544 2.523-5.05 7.047-3.726 11.19 1.325 4.144 5.176 6.956 9.526 6.956h34v256h-17c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h438c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10h-17v-256h34c4.35 0 8.201-2.812 9.525-6.956 1.325-4.143-.182-8.668-3.726-11.19zm-32.799 322.146h-418v-28h418zm-143-48h-132v-200h132zm-21-276c-5.523 0-10 4.477-10 10s4.477 10 10 10h137v256h-96v-210c0-5.523-4.477-10-10-10h-152c-5.523 0-10 4.477-10 10v210h-96v-256h137c5.523 0 10-4.477 10-10s-4.477-10-10-10h-159.709l204.709-145.725 204.709 145.725z"
                      />
                      <path
                        id="XMLID_1230_"
                        d="m227.67 354c2.63 0 5.21-1.07 7.07-2.93s2.93-4.44 2.93-7.07-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93c-2.64 0-5.22 1.07-7.07 2.93-1.87 1.86-2.93 4.44-2.93 7.07s1.06 5.21 2.93 7.07c1.86 1.86 4.43 2.93 7.07 2.93z"
                      />
                      <path
                        id="XMLID_1325_"
                        d="m248.93 170.93c-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.07 4.44 2.93 7.07 2.93 5.21-1.07 7.07-2.93 2.93-4.44 2.93-7.07-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93-5.21 1.07-7.07 2.93z"
                      />
                    </g>
                  </g>
                </svg>
                <h6>{{ _T('My Address') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="select-card pb-0">
        <div class="loyalty-point">
          <h6>{{ _T('Orders') }}</h6>
          <ul>
            <li>
              <router-link :to="{ name: 'profile.ongoing-orders' }">
                <svg
                  height="512pt"
                  viewBox="0 -14 512 512"
                  width="512pt"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m72.339844 274.179688c-2.988282 2.914062-3.050782 7.699218-.136719 10.6875 1.480469 1.519531 3.445313 2.28125 5.410156 2.28125 1.902344 0 3.808594-.710938 5.277344-2.144532 15.105469-14.722656 8.917969-26.839844 4.820313-34.859375-3.847657-7.523437-5.4375-10.640625 2.667968-18.269531 3.035156-2.859375 3.183594-7.644531.320313-10.679688-2.859375-3.042968-7.644531-3.183593-10.679688-.324218-16.371093 15.40625-9.992187 27.890625-5.769531 36.152344 3.691406 7.222656 5.21875 10.210937-1.910156 17.15625zm0 0"
                  />
                  <path
                    d="m114.175781 233.660156c-2.988281 2.914063-3.050781 7.699219-.136719 10.6875 1.480469 1.519532 3.445313 2.28125 5.414063 2.28125 1.898437 0 3.804687-.710937 5.273437-2.144531 15.113282-14.730469 8.910157-26.847656 4.804688-34.863281-3.851562-7.523438-5.445312-10.640625 2.65625-18.265625 3.039062-2.859375 3.183594-7.644531.324219-10.679688-2.863281-3.042969-7.648438-3.183593-10.683594-.324219-16.371094 15.410157-9.980469 27.894532-5.75 36.15625 3.695313 7.21875 5.222656 10.207032-1.902344 17.152344zm0 0"
                  />
                  <path
                    d="m225.222656 190.828125c1.957032 0 3.910156-.757813 5.390625-2.269531 2.460938-2.183594 13.464844-2.160156 15.894531.023437 2.945313 2.960938 7.730469 2.976563 10.6875.035157 2.960938-2.941407 2.976563-7.726563.035157-10.6875-5.464844-5.503907-14.804688-6.125-18.730469-6.125-.050781 0-.101562 0-.152344 0-3.773437.015624-13.128906.648437-18.523437 6.167968-2.917969 2.984375-2.875 7.78125.113281 10.699219 1.46875 1.4375 3.378906 2.15625 5.285156 2.15625zm0 0"
                  />
                  <path
                    d="m286.429688 190.828125c1.957031 0 3.910156-.757813 5.386718-2.269531 2.460938-2.183594 13.46875-2.160156 15.898438.023437 2.941406 2.960938 7.726562 2.976563 10.6875.035157 2.960937-2.941407 2.976562-7.726563.035156-10.6875-5.46875-5.503907-14.804688-6.125-18.730469-6.125-.054687 0-.105469 0-.152343 0-3.773438.015624-13.128907.648437-18.523438 6.167968-2.917969 2.984375-2.875 7.78125.109375 10.695313 1.472656 1.441406 3.378906 2.160156 5.289063 2.160156zm0 0"
                  />
                  <path
                    d="m269.886719 98.144531c4.171875 0 7.554687-3.382812 7.554687-7.558593v-34.707032c0-4.171875-3.382812-7.554687-7.554687-7.554687-4.175781 0-7.558594 3.382812-7.558594 7.554687v34.707032c0 4.175781 3.382813 7.558593 7.558594 7.558593zm0 0"
                  />
                  <path
                    d="m218.574219 64.011719c-4.171875 0-7.554688 3.382812-7.554688 7.558593v34.679688c0 4.171875 3.382813 7.554688 7.554688 7.554688 4.175781 0 7.558593-3.382813 7.558593-7.554688v-34.679688c0-4.175781-3.382812-7.558593-7.558593-7.558593zm0 0"
                  />
                  <path
                    d="m321.195312 113.804688c4.171876 0 7.554688-3.382813 7.554688-7.558594v-34.679688c0-4.171875-3.382812-7.554687-7.554688-7.554687-4.175781 0-7.558593 3.382812-7.558593 7.554687v34.679688c0 4.175781 3.382812 7.558594 7.558593 7.558594zm0 0"
                  />
                  <path
                    d="m482.679688 261.980469c16.167968 0 29.320312-13.164063 29.320312-29.34375v-65.804688c0-16.175781-13.152344-29.339843-29.320312-29.339843h-32.082032c-16.167968 0-29.320312 13.164062-29.320312 29.339843v65.804688c0 16.179687 13.152344 29.34375 29.320312 29.34375h8.484375v105.828125h-6.257812c-2.164063 0-4.265625.273437-6.269531.785156l-7.210938-30.546875c-8.378906-35.519531-37.878906-54.726563-87.683594-57.085937-.035156-.003907-.070312-.003907-.105468-.003907-4.011719-.132812-7.4375-.855469-10.464844-2.292969-.117188-.054687-.230469-.117187-.351563-.167968-3.605469-1.789063-6.648437-4.632813-9.449219-8.746094 1.609376-1.238281 3.203126-2.503906 4.746094-3.824219 21.847656-18.652343 33.875-42.316406 33.875-66.640625v-48.652344c.113282-.746093.109375-1.484374 0-2.199218v-49.605469c14.152344-10.375 19.992188-25.207031 15.65625-40.367187-5.285156-18.480469-24.148437-31.386719-45.878906-31.386719h-21.316406c-6.574219-15.167969-20.871094-25.042969-39.273438-26.804688-22.3125-2.132812-44.027344 8.515625-55.496094 26.804688h-20.363281c-22.042969 0-41.183593 13.097656-46.546875 31.851562-4.285156 14.996094 1.449219 29.652344 15.394532 39.898438v87.15625.070312 17.15625c0 25.480469 15.523437 45.527344 28.546874 57.851563 3.121094 2.957031 6.425782 5.769531 9.855469 8.425781-2.859375 4.273437-5.96875 7.214844-9.679687 9.042969-.011719.007812-.019532.011718-.03125.015625-3.09375 1.519531-6.601563 2.277343-10.730469 2.414062-.035156 0-.070313.003907-.105469.003907-7.644531.363281-14.808594 1.125-21.492187 2.28125-.027344.003906-.054688.007812-.082031.015624-32.890626 5.707032-54.136719 21.011719-63.359376 45.667969h-79.464843c-14.085938 0-25.542969 11.476563-25.542969 25.585938 0 14.09375 11.457031 25.5625 25.542969 25.5625h19.640625c7.554687 17.566406 19.242187 32.527343 34.167968 43.804687h-7.347656c-12.3125 0-22.328125 10.023438-22.328125 22.34375v15.433594c0 12.320312 10.015625 22.34375 22.328125 22.34375h44.261719c4.171875 0 7.554687-3.382812 7.554687-7.554688 0-4.175781-3.382812-7.558593-7.554687-7.558593h-44.261719c-3.980468 0-7.214844-3.242188-7.214844-7.230469v-15.433594c0-3.988281 3.238282-7.230468 7.214844-7.230468h157.394532c3.472656 0 6.378906 2.46875 7.066406 5.75.023437.25.0625.496093.113281.742187.027344.242187.039063.488281.039063.738281v15.433594c0 3.988281-3.238282 7.230469-7.21875 7.230469h-78.710938c-4.171875 0-7.554688 3.382812-7.554688 7.558593 0 4.171876 3.382813 7.554688 7.554688 7.554688h78.710938c12.316406 0 22.332031-10.023438 22.332031-22.34375v-10.164062h175.804687c.632813 13.429687 11.730469 24.15625 25.285156 24.15625h13.816407c21.578125 0 39.132812-17.566407 39.132812-39.160157v-29.519531c0-19.003906-13.601562-34.886719-31.578125-38.417969v-106.570312zm-58.046876 79.539062 8.445313 35.792969c-3.480469 4.339844-5.570313 9.84375-5.570313 15.832031v43.234375h-21.492187l-12.355469-71.546875c-1.527344-9.109375-6.757812-15.972656-13.824218-18.824219v-45.941406c25.015624 6.40625 39.761718 20.101563 44.796874 41.453125zm-59.910156-44.273437v47.3125h-19.367187v-49.023438c1.785156.277344 3.660156.457032 5.640625.523438 4.816406.230468 9.382812.632812 13.726562 1.1875zm-70.941406 47.3125c-3.890625-9.179688-12.984375-15.632813-23.558594-15.632813h-58.273437v-23.03125c14.414062 10.519531 35.324219 15.21875 53.648437 15.921875 1.601563.0625 3.234375.09375 4.890625.09375 19.941407 0 43.519531-4.578125 59.753907-16.671875v39.320313zm-36.476562 14.660156c1.242187-5.621094 1.40625-10.773438.53125-15.183594h12.386718c5.765625 0 10.457032 4.699219 10.457032 10.476563 0 5.761719-4.691407 10.445312-10.457032 10.445312h-14.359375c.527344-1.894531 1.011719-3.804687 1.441407-5.738281zm97.492187-203.640625v20.367187c-7.589844-3.289062-17.351563-10.175781-18.8125-24.027343 6.28125 1.066406 12.554687 2.289062 18.8125 3.660156zm-149.105469-3.652344c-1.457031 13.542969-10.886718 20.445313-18.492187 23.839844v-20.203125c6.152343-1.363281 12.320312-2.574219 18.492187-3.636719zm-18.492187 51.28125v-11.332031c4.683593-1.527344 11.078125-4.234375 17.0625-8.855469 7.730469-5.960937 16.378906-16.414062 16.75-33.421875 11.382812-1.5 22.753906-2.492187 34.039062-2.953125 4.171875-.167969 7.414063-3.6875 7.246094-7.855469-.171875-4.171874-3.710937-7.398437-7.859375-7.246093-13.894531.566406-27.90625 1.902343-41.917969 3.980469-.0625.003906-.125.003906-.1875.011718-.269531.03125-.53125.074219-.792969.128906-8.121093 1.226563-16.242187 2.703126-24.34375 4.429688v-45.273438c0-2.609374-1.34375-5.035156-3.5625-6.414062-10.753906-6.699219-15.164062-15.691406-12.40625-25.328125 2.964844-10.378906 14.914063-20.890625 32.011719-20.890625h24.75c2.835938 0 5.433594-1.585938 6.726563-4.109375 9.066406-17.691406 28.09375-24.183594 42.941406-22.761719 14.125 1.351563 24.652344 9.359375 28.160156 21.425782.9375 3.226562 3.894532 5.445312 7.257813 5.445312h26.613281c17.523438 0 28.53125 10.59375 31.34375 20.433594 2.757812 9.652344-1.859375 19.050781-12.671875 25.785156-2.21875 1.378906-3.5625 3.804688-3.5625 6.414062v45.277344c-8.144531-1.710937-16.3125-3.164062-24.480469-4.386718-.3125-.074219-.632812-.140626-.960937-.175782-.101563-.011718-.203125-.011718-.304688-.019531-12.730469-1.863281-25.457031-3.144531-38.085937-3.796875-4.148438-.21875-7.722656 2.988281-7.9375 7.15625s2.992187 7.722656 7.160156 7.9375c10.109375.519531 20.289062 1.476562 30.484375 2.808594.363281 17.742187 9.6875 28.398437 18.015625 34.394531 5.765625 4.148437 11.734375 6.585937 16.109375 7.972656v7.296875c0 19.828125-10.148437 39.414063-28.574219 55.148438-16.375 13.976562-37.8125 23.289062-55.9375 24.300781-.441406.023437-.898437.039063-1.371094.039063-10.601562-.003907-27.695312-6.167969-43.796874-17.296876-.246094-.195312-.507813-.371093-.773438-.535156-4.589844-3.222656-9.085938-6.851562-13.320312-10.859375-10.867188-10.285156-23.824219-26.769531-23.824219-46.875zm81.71875 90.679688c.746093 0 1.484375-.023438 2.203125-.0625 15.480468-.863281 32.328125-6.488281 47.648437-15.582031 2.226563 3.273437 4.976563 6.535156 8.4375 9.355468-12.335937 14.292969-38.480469 19.980469-61.027343 19.117188-23.433594-.898438-43.140626-8.378906-51.734376-19.15625 3.492188-2.859375 6.253907-6.164063 8.492188-9.476563 15.910156 9.769531 32.875 15.804688 45.980469 15.804688zm-78.3125 2.175781c2.203125-.078125 4.273437-.296875 6.234375-.628906v33.492187h-19.367188v-31.757812c4.164063-.511719 8.535156-.886719 13.132813-1.105469zm-28.246094 3.851562v29.011719h-40.867187c7.304687-14.40625 20.824218-24.015625 40.867187-29.011719zm-136.816406 65.042969c-5.75 0-10.429688-4.683593-10.429688-10.445312 0-5.777344 4.679688-10.476563 10.429688-10.476563h12.394531c-.878906 4.410156-.714844 9.5625.527344 15.183594v.011719c.429687 1.933593.917968 3.839843 1.433594 5.726562zm84.148437 58.921875c-28.9375-11.847656-49.480468-36.527344-56.46875-67.921875-1.28125-5.785156-.679687-9.894531.417969-11.265625.160156-.195312.527344-.652344 2.179687-.652344h54.613282.027344.023437 129.460937c1.664063 0 2.035157.457032 2.191407.652344 1.09375 1.363282 1.6875 5.46875.410156 11.261719-6.75 30.492187-27.527344 55.78125-55.722656 67.925781zm139.75 12.5c-3.644531-7.398437-11.257812-12.5-20.039062-12.5h-13.035156c14.800781-11.410156 26.566406-26.480468 34.136718-43.808594h19.71875c12.335938 0 22.65625-8.769531 25.050782-20.402343h77.003906c5.042968 0 6.34375 6.878906 6.480468 7.699219l11.921876 69.011718zm241.214844-29.410156v29.519531c0 13.257813-10.773438 24.046875-24.019531 24.046875h-13.8125c-5.628907 0-10.207031-4.597656-10.207031-10.25v-57.140625c0-3.121093 1.40625-5.914062 3.613281-7.789062.070312-.054688.136719-.109375.203125-.167969 1.75-1.414062 3.972656-2.265625 6.386718-2.265625h13.816407c13.246093 0 24.019531 10.789063 24.019531 24.046875zm-54.269531-174.332031v-65.804688c0-7.84375 6.375-14.226562 14.210937-14.226562h32.082032c7.832031 0 14.207031 6.382812 14.207031 14.226562v65.804688c0 7.847656-6.375 14.230469-14.207031 14.230469h-32.082032c-7.835937 0-14.210937-6.382813-14.210937-14.230469zm0 0"
                  />
                </svg>
                <h6>{{ _T('Ongoing Orders') }}</h6>
                <span>
                  <img src="/images/svg/global/chevron-right.svg" alt="" />
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'profile.scheduled-orders' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M16 11H13V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13H16C16.2652 13 16.5196 12.8946 16.7071 12.7071C16.8946 12.5196 17 12.2652 17 12C17 11.7348 16.8946 11.4804 16.7071 11.2929C16.5196 11.1054 16.2652 11 16 11Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('Scheduled Orders') }}</h6>
                <span>
                  <img src="/images/svg/global/chevron-right.svg" alt="" />
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'profile.history' }">
                <svg
                  id="Capa_1"
                  enable-background="new 0 0 551.13 551.13"
                  height="512"
                  viewBox="0 0 551.13 551.13"
                  width="512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m275.531 172.228-.05 120.493c0 4.575 1.816 8.948 5.046 12.177l86.198 86.181 24.354-24.354-81.153-81.136.05-113.361z"
                  />
                  <path
                    d="m310.011 34.445c-121.23 0-221.563 90.033-238.367 206.674h-71.644l86.114 86.114 86.114-86.114h-65.78c16.477-97.589 101.355-172.228 203.563-172.228 113.966 0 206.674 92.707 206.674 206.674s-92.707 206.674-206.674 206.674c-64.064 0-123.469-28.996-162.978-79.555l-27.146 21.192c46.084 58.968 115.379 92.808 190.124 92.808 132.955 0 241.119-108.181 241.119-241.119s-108.164-241.119-241.119-241.12z"
                  />
                </svg>
                <h6>{{ _T('Past Orders') }}</h6>
                <span>
                  <img src="/images/svg/global/chevron-right.svg" alt="" />
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="select-card pb-0">
        <div class="loyalty-point">
          <h6>{{ _T('Payment') }}</h6>
          <ul>
            <li v-if="isModuleEnable('Loyalty')">
              <router-link :to="{ name: 'profile.wallet' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 7H18V6C18 5.20435 17.6839 4.44129 17.1213 3.87868C16.5587 3.31607 15.7956 3 15 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V18C2 18.7956 2.31607 19.5587 2.87868 20.1213C3.44129 20.6839 4.20435 21 5 21H19C19.7956 21 20.5587 20.6839 21.1213 20.1213C21.6839 19.5587 22 18.7956 22 18V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7ZM5 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM20 15H19C18.7348 15 18.4804 14.8946 18.2929 14.7071C18.1054 14.5196 18 14.2652 18 14C18 13.7348 18.1054 13.4804 18.2929 13.2929C18.4804 13.1054 18.7348 13 19 13H20V15ZM20 11H19C18.2044 11 17.4413 11.3161 16.8787 11.8787C16.3161 12.4413 16 13.2044 16 14C16 14.7956 16.3161 15.5587 16.8787 16.1213C17.4413 16.6839 18.2044 17 19 17H20V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V8.83C4.32127 8.94302 4.65943 9.00051 5 9H19C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10V11Z"
                    fill="black"
                  ></path>
                </svg>
                <h6>{{ _T('My Cashback') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'mobile-saved-cards' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6956 4.97949H4.80178C3.52517 4.97949 2.49707 6.00759 2.49707 7.2842V17.2137C2.49707 18.4903 3.52517 19.5184 4.80178 19.5184H19.6956C20.9722 19.5184 22.0003 18.4903 22.0003 17.2137V7.28505C22.0003 6.00844 20.9722 4.97949 19.6956 4.97949ZM4.26986 11.7174H20.2275V17.2137C20.2275 17.4971 19.979 17.7456 19.6956 17.7456H4.80178C4.51837 17.7456 4.26986 17.4971 4.26986 17.2137V11.7174ZM4.80178 6.75313H19.6956C19.979 6.75313 20.2275 7.00164 20.2275 7.28505V8.88081H4.26986V7.28505C4.26986 7.00081 4.51837 6.75313 4.80178 6.75313Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M6.32774 16.6816H8.81032C9.30649 16.6816 9.69714 16.2918 9.69714 15.7948V13.6671C9.69714 13.1709 9.30734 12.7803 8.81032 12.7803H6.32774C5.83156 12.7803 5.44092 13.1701 5.44092 13.6671V15.7948C5.44092 16.2918 5.83071 16.6816 6.32774 16.6816Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('Saved Card') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="select-card pb-0">
        <div class="loyalty-point">
          <h6>{{ _T('Language') }}</h6>
          <ul>
            <li>
              <a @click="$bvModal.show('language-modal')">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12ZM19.93 11H17C16.8351 8.64814 16.0293 6.38635 14.67 4.46C16.0665 4.95597 17.2977 5.83007 18.2265 6.98484C19.1553 8.13962 19.745 9.52967 19.93 11ZM9.08 13H15C14.7441 15.4706 13.6911 17.7908 12 19.61C10.3101 17.7984 9.28119 15.4693 9.08 13ZM9.08 11C9.31289 8.54183 10.3376 6.22572 12 4.4C13.7047 6.20612 14.7601 8.52804 15 11H9.08ZM9.44 4.43C8.07355 6.36702 7.2548 8.63672 7.07 11H4.07C4.2589 9.5115 4.86261 8.10612 5.81217 6.94437C6.76172 5.78262 8.01886 4.91133 9.44 4.43ZM4.07 13H7.07C7.23469 15.3613 8.04788 17.6313 9.42 19.56C8.00397 19.0763 6.75199 18.2052 5.80627 17.0456C4.86055 15.886 4.25902 14.4844 4.07 13ZM14.62 19.55C15.9884 17.6207 16.8107 15.3577 17 13H19.95C19.7609 14.4802 19.1615 15.8781 18.2196 17.0356C17.2778 18.193 16.0309 19.064 14.62 19.55Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6 class="lang-select">{{ _T('English') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="select-card pb-0">
        <div class="loyalty-point">
          <h6>{{ _T('Support') }}</h6>
          <ul>
            <li>
              <router-link :to="{ name: 'help' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.031 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.7411 9.25718 8.87418C9.23529 9.00726 9.24055 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52854 9.44389 9.63643C9.52481 9.74433 9.62671 9.83475 9.74348 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.3474 11.345 9.22078 11.4978 9.13298C11.6505 9.04518 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71352C13.3828 7.25801 12.7035 7.00546 12 7Z"
                    fill="black"
                  ></path>
                </svg>
                <h6>{{ _T('Help') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'terms' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.903 8.586C19.854 8.48 19.793 8.379 19.707 8.293L13.707 2.293C13.621 2.207 13.52 2.146 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.236 2.036 13.15 2.018 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.982 8.849 19.965 8.763 19.936 8.679C19.926 8.647 19.917 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.553 12.447 10 13 10H18L18.002 20H6Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('Terms and Conditions') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'privacy' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.903 8.586C19.854 8.48 19.793 8.379 19.707 8.293L13.707 2.293C13.621 2.207 13.52 2.146 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.236 2.036 13.15 2.018 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.982 8.849 19.965 8.763 19.936 8.679C19.926 8.647 19.917 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.553 12.447 10 13 10H18L18.002 20H6Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('Privacy Policy') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'faq' }">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" fill="white"></rect>
                  <path
                    d="M2.75 4.5C2.75 3.5335 3.5335 2.75 4.5 2.75H19.5C20.4665 2.75 21.25 3.5335 21.25 4.5V19.5C21.25 20.4665 20.4665 21.25 19.5 21.25H4.5C3.5335 21.25 2.75 20.4665 2.75 19.5V4.5Z"
                    stroke="#3D3F43"
                    stroke-width="1.5"
                  ></path>
                  <path
                    d="M5.88343 14.6895V12.2643H8.39781V11.4H5.88343V9.95664H8.45067V9.09231H5V14.6895H5.88343Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M13.6413 14.6895L11.663 9.09231H10.5606L8.58233 14.6895H9.58658L9.95656 13.607H12.2671L12.6371 14.6895H13.6413ZM12.0179 12.7427H10.2057L11.1118 10.0741L12.0179 12.7427Z"
                    fill="#3D3F43"
                  ></path>
                  <path
                    d="M16.4252 14.7902C16.8934 14.7902 17.3237 14.6727 17.6937 14.4545L18.1317 15L18.7433 14.4294L18.328 13.9091C18.7508 13.3972 19 12.7007 19 11.8951C19 10.2252 17.9278 9 16.4252 9C14.9151 9 13.8504 10.2252 13.8504 11.8951C13.8504 13.565 14.9151 14.7902 16.4252 14.7902ZM16.4252 13.9175C15.4059 13.9175 14.7565 13.0448 14.7565 11.8951C14.7565 10.7371 15.4059 9.87273 16.4252 9.87273C17.437 9.87273 18.0939 10.7371 18.0939 11.8951C18.0939 12.3902 17.9731 12.835 17.7541 13.179L17.1274 12.3902L16.5083 12.9608L17.135 13.7497C16.9236 13.8587 16.6895 13.9175 16.4252 13.9175Z"
                    fill="#3D3F43"
                  ></path>
                </svg>
                <h6>{{ _T('FAQ') }}</h6>
                <span
                  ><img src="/images/svg/global/chevron-right.svg" alt=""
                /></span>
              </router-link>
            </li>
            <!-- <li class="text-center">
              <h6 class="version">{{ _T('VERSION 19.12.11 (V2.91)') }}</h6>
            </li> -->
          </ul>
          <div class="logout-btn">
            <button
              type="button"
              class="btn btn-outline btn-block"
              @click="$bvModal.show('log-out')"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.41 10.9999L13.71 8.7099C13.8037 8.61694 13.8781 8.50633 13.9289 8.38447C13.9797 8.26262 14.0058 8.13191 14.0058 7.9999C14.0058 7.86789 13.9797 7.73718 13.9289 7.61532C13.8781 7.49346 13.8037 7.38286 13.71 7.2899C13.617 7.19617 13.5064 7.12177 13.3846 7.07101C13.2627 7.02024 13.132 6.9941 13 6.9941C12.868 6.9941 12.7373 7.02024 12.6154 7.07101C12.4936 7.12177 12.383 7.19617 12.29 7.2899L8.29 11.2899C8.19896 11.385 8.12759 11.4971 8.08 11.6199C7.97998 11.8634 7.97998 12.1364 8.08 12.3799C8.12759 12.5026 8.19896 12.6148 8.29 12.7099L12.29 16.7099C12.3832 16.8031 12.4939 16.8771 12.6158 16.9276C12.7376 16.978 12.8681 17.004 13 17.004C13.1319 17.004 13.2624 16.978 13.3843 16.9276C13.5061 16.8771 13.6168 16.8031 13.71 16.7099C13.8032 16.6167 13.8772 16.506 13.9277 16.3841C13.9781 16.2623 14.0041 16.1318 14.0041 15.9999C14.0041 15.868 13.9781 15.7375 13.9277 15.6156C13.8772 15.4938 13.8032 15.3831 13.71 15.2899L11.41 12.9999L21 12.9999C21.2652 12.9999 21.5196 12.8945 21.7071 12.707C21.8946 12.5195 22 12.2651 22 11.9999C22 11.7347 21.8946 11.4803 21.7071 11.2928C21.5196 11.1053 21.2652 10.9999 21 10.9999L11.41 10.9999ZM12 21.9999C13.8689 22.0082 15.7028 21.4927 17.2935 20.5117C18.8843 19.5307 20.1683 18.1236 21 16.4499C21.1193 16.2112 21.139 15.9349 21.0546 15.6817C20.9702 15.4285 20.7887 15.2192 20.55 15.0999C20.3113 14.9806 20.035 14.9609 19.7818 15.0453C19.5286 15.1297 19.3193 15.3112 19.2 15.5499C18.5678 16.8266 17.6062 17.9113 16.4145 18.6919C15.2227 19.4725 13.8442 19.9208 12.4212 19.9903C10.9983 20.0598 9.58262 19.7481 8.32048 19.0874C7.05834 18.4267 5.99553 17.4409 5.24189 16.2319C4.48825 15.0229 4.07112 13.6347 4.0336 12.2105C3.99608 10.7864 4.33954 9.37805 5.02849 8.13109C5.71743 6.88412 6.72686 5.84374 7.95246 5.11747C9.17807 4.3912 10.5754 4.00539 12 3.9999C13.4911 3.99344 14.9538 4.40753 16.2203 5.19465C17.4868 5.98177 18.5056 7.11001 19.16 8.4499C19.2793 8.68859 19.4886 8.8701 19.7418 8.95449C19.995 9.03888 20.2713 9.01924 20.51 8.8999C20.7487 8.78055 20.9302 8.57127 21.0146 8.3181C21.099 8.06492 21.0793 7.78859 20.96 7.5499C20.1672 5.95439 18.9625 4.59966 17.4705 3.62585C15.9786 2.65204 14.2536 2.0945 12.4739 2.01091C10.6942 1.92732 8.92452 2.32071 7.34786 3.15039C5.7712 3.98007 4.44482 5.2159 3.50593 6.73008C2.56704 8.24424 2.04973 9.98176 2.0075 11.7629C1.96528 13.544 2.39967 15.3041 3.26576 16.8611C4.13184 18.418 5.39816 19.7153 6.93373 20.6188C8.4693 21.5223 10.2184 21.9991 12 21.9999Z"
                ></path>
              </svg>
              <span>{{ _T('Logout') }}</span>
            </button>
          </div>
        </div>
      </div>
      <language-picker />
      <confirm-logout />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguagePicker from '@/components/Modals/LanguagePicker'
import ConfirmLogout from '@/components/Modals/ConfirmLogout.vue'
export default {
  name: 'MobileChangeProfile',
  computed: {
    ...mapGetters([
      'is_customer_logged_in',
      '_T',
      'web_user',
      'loyalty_balance',
      'domainBasedBrand',
      'currentBrand',
      '_T_DB',
      'isModuleEnable',
    ]),
  },
  components: {
    LanguagePicker,
    ConfirmLogout,
  },
}
</script>

<style lang="scss" scoped>
#accountprofile,
.mobile-fix-option,
#loyalty-point,
#loyalty-use {
  &.hide {
    display: none;
  }

  &.show {
    display: block;
  }
}
.profile-account {
  .iti--allow-dropdown {
    .iti__country-list {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      border-radius: $px10 $px10 0 0;
    }

    .iti__dial-code {
      float: right;
    }

    .iti__country {
      padding: $px10;
    }
  }

  .select-card {
    .btn-fix {
      position: fixed;
      padding: $px20;
      left: 0;
      margin: 0 auto;
      bottom: 0;
      right: 0;
      background-color: $white;
      z-index: 1;
    }
  }
}
.mobile-card-select {
  height: 100vh;
  position: relative;

  .checkout-card {
    text-align: center;
    padding: $px18 $px20;
    background-color: $white;
    border-bottom: $px12 solid $light-border;

    h4 {
      position: relative;
      margin-bottom: 0;
      font-weight: bold;
      text-transform: capitalize;

      .skip-this {
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.02em;
        color: $light-font;
        position: absolute;
        right: $px2;
        top: $px4;
      }
    }

    .back-cart {
      position: absolute;
      top: $px18;
      left: $px20;
      z-index: 1;
    }
  }

  .my-account {
    padding: $px10 $px20 $px10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: $px1 solid $light-border;

    h4 {
      margin-bottom: 0;
      font-weight: 600;
      font-size: $px18;
      letter-spacing: -0.02em;
    }

    .badge {
      float: right;
      color: rgba(var(--color-warning-color-source), 0.8);
      font-weight: normal;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.583333px;
      padding: $px4 $px10;
      background-color: rgba(var(--color-warning-color-source), 0.2);
      border-radius: $px6;
    }
  }

  .loyalty-point {
    > h6 {
      font-weight: 600;
      font-size: $px12;
      line-height: $px15;
      letter-spacing: 0.02em;
      color: $light-font;
      margin-bottom: 0 !important;
      text-transform: uppercase;
    }

    .media {
      margin-top: $px20;

      .media-body {
        margin-left: $px18;

        h6 {
          line-height: $px17;
          letter-spacing: 0.02em;
        }

        h4 {
          font-weight: 600;
          font-size: $px18;
        }
      }
    }

    ul {
      li {
        display: block;
        padding: $px26 0;

        a {
          color: $font-color;
          display: block;
        }

        + li {
          border-top: $px1 solid $light-border;
        }

        svg {
          vertical-align: -$px6;
          width: 24px;
          height: 24px;
        }

        h6 {
          display: inline-block;
          margin-bottom: 0;
          margin-left: $px4;
        }

        span {
          float: right;
        }

        .version {
          margin-left: 0;
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $light-font;
        }
      }
    }

    .logout-btn {
      padding-bottom: $px65;

      button {
        border-width: $px2;

        svg {
          vertical-align: bottom;
          margin-right: $px2;

          path {
            fill: $color-primary;
          }
        }

        &:hover {
          svg {
            path {
              fill: $white;
            }
          }
        }
      }
    }
  }

  .media-user {
    padding: $px16;
    align-items: center;

    img {
      padding: $px4;
      border: $px1 solid $light-border;
      border-radius: 100%;
      width: $px74;
      height: $px74;
    }

    .media-body {
      padding-left: $px12;

      h5 {
        font-weight: 600;
        font-size: $px16;
        color: $black;
        margin-bottom: $px3;
      }

      span {
        font-size: $px13;
        line-height: $px16;
        display: block;
        letter-spacing: 0.02em;
        color: $light-font;
        margin-bottom: $px6;
      }

      a {
        font-weight: 600;
        font-size: $px13;
        line-height: $px16;
      }
    }

    &.text-center {
      img {
        width: $px82;
        height: $px82;
      }

      .change-photo {
        position: relative;

        a {
          &.icon-change {
            width: $px30;
            height: $px30;
            background-color: $color-primary;
            display: flex;
            align-items: center;
            justify-content: center;
            border: $px1 solid $white;
            border-radius: 100%;
            position: absolute;
            right: 40%;
            bottom: 0;

            img {
              padding: 0;
              border: none;
              width: auto;
              height: auto;
            }
          }
        }

        input {
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: $px28;
          opacity: 0;
          bottom: 0;
          cursor: pointer;
        }
      }
    }
  }

  .select-card {
    padding: $px20;
    margin-bottom: $px12;

    + .select-card {
      margin-bottom: $px120;
      border-top: $px12 solid $light-border;
    }

    h6 {
      font-weight: 600;
      line-height: $px22;
      letter-spacing: 0.5px;
      margin-bottom: $px4;
    }

    .add-new-card {
      margin-top: 0;

      ul {
        li {
          display: block;

          label {
            span {
              text-align: left;
              padding: $px10 $px15;

              .media {
                .media-body {
                  margin-left: $px14;

                  span {
                    border: none;
                    padding: 0;
                    line-height: $px17;
                    letter-spacing: 0.04em;
                    color: $light-font;
                  }
                }
              }
            }
          }

          .link-add-card {
            padding: $px18;
            text-align: center;
            border: $px1 dashed $light-border;
            border-radius: $px4;

            a {
              font-weight: 600;
              letter-spacing: 0.04em;
            }
          }
        }
      }
    }
  }

  .added-product {
    li {
      display: flex;
      position: relative;
      min-height: $px87;
      &:last-child {
        min-height: $px70;
      }
      .detail {
        margin-left: $px18;
        width: 100%;

        h6 {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $font-color;
          text-transform: capitalize;
          margin-bottom: $px2;

          span {
            float: right;
          }
        }

        p {
          max-width: $px180;
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.5px;
          color: $light-font;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow: hidden;
          margin-bottom: 0;
        }

        a {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $warning-color;
          align-items: center;
          display: flex;
          margin-top: $px6;

          svg {
            margin-left: $px3;
          }
        }
      }

      .qty-box {
        margin-left: 0;
        position: absolute;
        right: 0;
        bottom: 0;

        .form-control {
          width: $px32;
          height: $px32;
        }

        .input-group {
          .btn {
            width: $px32;
          }
        }
      }

      + li {
        padding-top: $px20;
        margin-top: $px20;
        border-top: 1px solid $light-border;
      }
    }
    .removed-item {
      min-height: unset;
    }
    .btn-add {
      width: 100%;
      border: $px1 dashed $light-border;
      border-radius: $px4;
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.04em;
      color: $color-primary;
      background-color: $white;
      text-transform: capitalize;
      padding: $px15;
    }
  }

  &.profile-account {
    height: auto;

    .checkout-card {
      text-align: left;
      border-bottom: none;
      padding: 0;

      h4 {
        padding: $px10 $px20 $px10 $px50;
        border-bottom: $px1 solid $light-border;
        font-weight: 600;
      }

      .back-cart {
        top: $px10;

        .back-loyalty,
        .back-carry {
          img {
            width: $px16;
          }
        }
      }
    }

    .select-card {
      + .select-card {
        margin-bottom: 0;
      }
    }
  }

  .bill-amount {
    padding: $px15 $px20;
    border-top: $px18 solid $light-border;
    background-color: $white;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;

    h6 {
      font-weight: bold;
      line-height: $px17;
      letter-spacing: 0.005em;
      margin-bottom: $px10;

      span {
        float: right;
        font-size: $px16;
        line-height: $px19;
      }
    }
  }
}
.mobile-login {
  display: none;
}
@media (max-width: 767px) {
  .mobile-login {
    display: block;
    .login-card-mobile {
      text-align: left;
      border-bottom: none;
      padding: 0;
      .back-cart {
        position: absolute;
        top: $px10;
        left: $px20;
        z-index: 1;
        .rightarrow {
          width: $px16;
          height: $px16;
        }
      }
      h4 {
        padding: $px10 $px20 $px10 $px50;
        border-bottom: $px1 solid $light-border;
        font-weight: 600;
      }
      .login-btns {
        padding: $px30;
        display: block;
      }
    }
  }
}
.body-rtl {
  @media (max-width: 767px) {
    .mobile-card-select {
      .media-user {
        .media-body {
          padding-left: unset;
          padding-right: 0.75rem;
        }
      }
      text-align: right;
      ul {
        li {
          h6 {
            margin-left: unset;
            margin-right: 0.25rem;
          }
          span {
            float: left;
          }
          img {
            transform: scaleX(-1);
          }
        }
      }
    }
    .select-card {
      ul {
        padding-right: 0;
        padding-left: unset;
      }
    }
  }
}
</style>
